import { alignClasses, type Color, fontClasses, sizeClasses, type TextAlign, type TextSize, type Weight } from "@/types/ui/design";
import React, { type JSX } from "react";

type PennTextProps = {
  children: React.ReactNode;
  size?: TextSize;
  align?: TextAlign;
  color?: Color;
  font?: Weight;
  className?: string;
  as?: keyof JSX.IntrinsicElements;
};

const PennText = ({
  children,
  size = "sm",
  color = "blue_grey",
  font = "normal",
  align="start",
  className = "",
  as: Component = "p",
}: PennTextProps) => {
    
  return (
    <Component
      className={`${sizeClasses[size]} ${fontClasses[font]}  ${alignClasses[align]}  ${className} ${`text-${color}`}`}
    >
      {children}
    </Component>
  );
};

export default PennText;